import React, { useState, useEffect } from "react";
import { getTemplate } from "./TableStrategies/TableFactory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const DynamicTable = ({ sections, onSubmit, initialValues = {} }) => {
  const initializeState = (sections, initialValues) => {
    const state = {};
    sections.forEach((section) => {
      section.rows.forEach((row) => {
        row.values.forEach((name) => {
          state[name] = initialValues[name] || ""; // Используем начальное значение, если оно есть
        });
      });
    });
    return state;
  };

  const [inputValues, setInputValues] = useState(
    initializeState(sections, initialValues)
  );
  const [disabledInputs, setDisabledInputs] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [lastSaved, setLastSaved] = useState(null);

  // Функция для применения правил
  const applyRules = (rules) => {
    const newDisabledInputs = { ...disabledInputs };

    if (rules) {
      rules.forEach((rule) => {
        if (rule.type === "sum") {
          const sum = rule.sources.reduce(
            (acc, source) => acc + (parseFloat(inputValues[source]) || 0),
            0
          );
          setInputValues((prevState) => ({
            ...prevState,
            [rule.target]: sum.toString(),
          }));
        }

        if (rule.type === "gte") {
          const sum = rule.sources.reduce(
            (acc, source) => acc + (parseFloat(inputValues[source]) || 0),
            0
          );
          if (parseFloat(inputValues[rule.target]) < sum) {
            toast.error("Значение может быть только больше или равно");
            setInputValues((prevState) => ({
              ...prevState,
              [rule.target]: sum.toString(),
            }));
          }
        }

        if (rule.type === "lte") {
          const sum = rule.sources.reduce(
            (acc, source) => acc + (parseFloat(inputValues[source]) || 0),
            0
          );
          if (parseFloat(inputValues[rule.target]) > sum) {
            toast.error("Значение может быть только меньше или равно");
            setInputValues((prevState) => ({
              ...prevState,
              [rule.target]: sum.toString(),
            }));
          }
        }

        if (rule.type === "disabled") {
          newDisabledInputs[rule.target] = true;
        }
      });

      setDisabledInputs(newDisabledInputs);
    }
  };

  // Применяем правила при изменении inputValues
  useEffect(() => {
    sections.forEach((section) => {
      if (section.rules) {
        applyRules(section.rules);
      }
    });
  }, [inputValues, sections]);

  const handleInputChange = (name, newValue) => {
    setInputValues((prevState) => ({
      ...prevState,
      [name]: newValue,
    }));
    // Если пользователь изменил что-то после сохранения, сбрасываем статус сохранения
    if (lastSaved) {
      setLastSaved(null);
    }
  };
  
  const handleSubmit = async () => {
    setIsSubmitting(true);
    
    try {
      // Фильтруем только незаблокированные значения
      const validInputs = Object.keys(inputValues).reduce((acc, key) => {
        if (!disabledInputs[key]) {
          acc[key] = inputValues[key];
        }
        return acc;
      }, {});

      if (onSubmit) {
        await Promise.resolve(onSubmit(validInputs)); // Передаем данные в функцию-обработчик
        // Обновляем время последнего сохранения
        setLastSaved(new Date());
        toast.success("Данные успешно сохранены!");
      }
    } catch (error) {
      toast.error("Ошибка при сохранении данных");
      console.error("Ошибка при сохранении:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Определение текста кнопки в зависимости от состояния
  const getButtonText = () => {
    if (isSubmitting) return "Сохранение...";
    if (lastSaved) return "Сохранено";
    return "Сохранить";
  };

  return (
    <div>
      <ToastContainer />
      {sections.map((section, sectionIndex) => {
        const Template = getTemplate(section.type);
        return Template ? (
          <Template
            key={sectionIndex}
            {...section}
            inputValues={inputValues}
            disabledInputs={disabledInputs}
            onChange={handleInputChange}
          />
        ) : null;
      })}

      <button
        className="no-print"
        onClick={handleSubmit}
        disabled={isSubmitting}
        style={{
          marginTop: "20px",
          padding: "10px 20px",
          backgroundColor: lastSaved ? "#28a745" : isSubmitting ? "#6c757d" : "#007BFF",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          cursor: isSubmitting ? "not-allowed" : "pointer",
        }}
      >
        {getButtonText()}
      </button>
      
      {lastSaved && (
        <span style={{ 
          marginLeft: "15px", 
          color: "#28a745", 
          fontSize: "14px" 
        }}>
          Последнее сохранение: {lastSaved.toLocaleTimeString()}
        </span>
      )}
    </div>
  );
};

export default DynamicTable;
